import axios from "../../axios";
import axios_vendor from "../../axios-vendor";
import { Commit, Dispatch } from 'vuex'

const baseURL = "/options";

export default ({
    namespaced: true,
    state : {
        all_roles:[],
        all_business_units:[],
        all_vendors:[],
        all_users:[],
        all_ibps_status:[],
        all_check_statuses:[],
        all_payment_portal_status: [],
        all_payment_status_event: [],
        all_payment_mode: [],
        all_sites: [],
        all_sms_templates: [],
        all_email_templates: [],
        all_group_sms: [],
        all_group_email: [],
    },
    actions : {
        async getAllRoles({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/roles`, {params: {...payload}});
            commit("SET_ALL_ROLES", data);
            return data;
        },
        async getAllBusinessUnits({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/business_units`, {params: {...payload}});
            commit("SET_ALL_BUSINESS_UNITS", data);
            return data;
        },
        async getAllVendors({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/vendors`, {params: {...payload}});
            commit("SET_ALL_VENDORS", data);
            return data;
        },
        async getAllUsers({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/users`, {params: {...payload}});
            commit("SET_ALL_USERS", data);
            return data;
        },
        async getAllIbpsStatus({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/ibps_status`, {params: {...payload}});
            commit("SET_ALL_IBPS_STATUS", data);
            return data;
        },
        async getAllPaymentPortalStatus({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/payment_portal_status`, {params: {...payload}});
            commit("SET_ALL_PAYMENT_PORTAL_STATUS", data);
            return data;
        },
        async getAllPaymentPortalStatusVendor({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios_vendor.get(`${baseURL}/payment_portal_status`, {params: {...payload}});
            commit("SET_ALL_PAYMENT_PORTAL_STATUS", data);
            return data;
        },
        async getAllPaymentStatusEvent({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/payment_status_event`, {params: {...payload}});
            commit("SET_ALL_PAYMENT_STATUS_EVENT", data);
            return data;
        },
        async getAllCheckStatuses({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/check_statuses`, {params: {...payload}});
            commit("SET_ALL_CHECK_STATUSES", data);
            return data;
        },
        async getAllPaymentMode({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/payment_mode`, {params: {...payload}});
            commit("SET_ALL_PAYMENT_MODE", data);
            return data;
        },
        async getAllSites({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/sites`, {params: {...payload}});
            commit("SET_ALL_SITES", data);
            return data;
        },
        async getAllSitesVendor({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios_vendor.get(`${baseURL}/sites`, {params: {...payload}});
            commit("SET_ALL_SITES", data);
            return data;
        },
        async getAllVendorPerOrg({commit}: {commit: Commit},{org_id="all", search="", payload={}}) {
            const { data } = await axios.get(`${baseURL}/vendor_per_org`, {params: {...payload, org_id: org_id, search:search}});
            commit("SET_ALL_VENDORS", data);
            return data;
        },
        async getAllSmsTemplate({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/sms_templates`, {params: {...payload}});
            commit("SET_ALL_SMS_TEMPLATE", data);
            return data;
        },
        async getAllEmailTemplate({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/email_templates`, {params: {...payload}});
            commit("SET_ALL_EMAIL_TEMPLATE", data);
            return data;
        },
        async getAllGroupSms({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/group_sms`, {params: {...payload}});
            commit("SET_ALL_GROUP_SMS", data);
            return data;
        },
        async getAllGroupEmail({commit}: {commit: Commit}, payload={}) {
            const { data } = await axios.get(`${baseURL}/group_email`, {params: {...payload}});
            commit("SET_ALL_GROUP_EMAIL", data);
            return data;
        },
    },
    mutations:{
        SET_ALL_ROLES(state:any, data: any) {
            state.all_roles = data;
        },
        SET_ALL_BUSINESS_UNITS(state:any, data: any) {
            state.all_business_units = data;
        },
        SET_ALL_VENDORS(state:any, data: any) {
            state.all_vendors = data;
        },
        SET_ALL_USERS(state:any, data: any) {
            state.all_users = data;
        },
        SET_ALL_IBPS_STATUS(state:any, data: any) {
            state.all_ibps_status = data;
        },
        SET_ALL_CHECK_STATUSES(state:any, data: any) {
            state.all_check_statuses = data;
        },
        SET_ALL_PAYMENT_PORTAL_STATUS(state:any, data: any) {
            state.all_payment_portal_status = data;
        },
        SET_ALL_PAYMENT_STATUS_EVENT(state:any, data: any) {
            state.all_payment_status_event = data;
        },
        SET_ALL_PAYMENT_MODE(state:any, data: any) {
            state.all_payment_mode = data;
        },
        SET_ALL_SITES(state:any, data: any) {
            state.all_sites = data;
        },
        SET_ALL_SMS_TEMPLATE(state:any, data: any) {
            state.all_sms_templates = data;
        },
        SET_ALL_EMAIL_TEMPLATE(state:any, data: any) {
            state.all_email_templates = data;
        },
        SET_ALL_GROUP_SMS(state:any, data: any) {
            state.all_group_sms = data;
        },
        SET_ALL_GROUP_EMAIL(state:any, data: any) {
            state.all_group_email = data;
        },
    },
    getters:{
        all_roles(state: any){
            return state.all_roles;
        },
        all_business_units(state: any){
            return state.all_business_units;
        },
        all_vendors(state: any){
            return state.all_vendors;
        },
        all_users(state: any){
            return state.all_users;
        },
        all_ibps_status(state: any){
            return state.all_ibps_status;
        },
        all_check_statuses(state: any){
            return state.all_check_statuses;
        },
        all_payment_portal_status(state: any){
            return state.all_payment_portal_status;
        },
        all_payment_status_event(state: any){
            return state.all_payment_status_event;
        },
        all_payment_mode(state: any){
            return state.all_payment_mode;
        },
        all_sites(state: any){
            return state.all_sites;
        },
        all_sms_templates(state: any){
            return state.all_sms_templates;
        },
        all_email_templates(state: any){
            return state.all_email_templates;
        },
        all_group_sms(state: any){
            return state.all_group_sms;
        },
        all_group_email(state: any){
            return state.all_group_email;
        },
    }
});




